<div>
    <dx-scroll-view style="height: calc(100vh - 225px);margin-top:5px;">
        <dx-form #renamingParametersForm
                 class="scrolled-form"
                 labelLocation="left"
                 labelMode="outside"
                 [colCount]="2"
                 [showColonAfterLabel]="false">
            <dxi-item itemType="group" [caption]="'fileTransfersRenamingParameters.lblParameters' | translate" style="height: calc(100vh - 305px);">
                <dx-data-grid #renamingParametersGrid
                              height="100%"
                              hoverStateEnabled="true"
                              [dataSource]="dataSource"
                              [errorRowEnabled]="false"
                              [wordWrapEnabled]="true"
                              (onInitNewRow)="onNewRenamingParameter($event)"
                              (onRowUpdating)="onRowUpdating($event)">
                    <dxo-editing mode="row" [allowAdding]="false" [allowDeleting]="true" [allowUpdating]="true" [useIcons]="true" />
                    <dxo-header-filter [visible]="true" />
                    <dxo-paging [enabled]="false" />
                    <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate" />
                    <dxo-summary>
                        <dxi-total-item column="parameter" [displayFormat]="'fileTransfersRenamingParameters.lblParametersCount' | translate" summaryType="count"></dxi-total-item>
                    </dxo-summary>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="onAddButtonClick($event)"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="onRefreshButtonClick()" />
                            </div>
                        </dxi-item>
                        <dxi-item name="searchPanel"></dxi-item>
                    </dxo-toolbar>

                    <dxi-column dataField="parameter" [caption]="'fileTransfersRenamingParameters.lblParameter' | translate" />
                    <dxi-column dataField="rank" [caption]="'fileTransfersRenamingParameters.lblRank' | translate" [width]="100" />
                </dx-data-grid>
            </dxi-item>
            <dxi-item itemType="group">
                <dxi-item itemType="group" [caption]="'fileTransfersRenamingParameters.lblTestParameters' | translate">
                    <dxi-item>
                        <dxo-label [text]="'fileTransfersRenamingParameters.lblInitialFileName' | translate" />
                        <div *dxTemplate>
                            <dx-text-box [(value)]="testData.initial"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label [text]="'fileTransfersRenamingParameters.lblRenamedFileName' | translate" />
                        <div *dxTemplate>
                            <div style="width:100%">
                                <dx-text-box class="renamed-textbox" [readOnly]="true" [(value)]="testData.renamed" />
                                <dx-button icon="refresh" styling="outline" type="normal" (onClick)="testParameters($event)" />
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [caption]="'fileTransfersRenamingParameters.lblRecognizedVariables' | translate">
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%DateTime%')">
                                <span class="variable-title">%DateTime%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarDateTime</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%DateTimeUtc%')">
                                <span class="variable-title">%DateTimeUtc%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarDateTimeUtc</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%DateTime:format%')">
                                <span class="variable-title">%DateTime:format%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarDateTimeFormat</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%DateTimeUtc:format%')">
                                <span class="variable-title">%DateTimeUtc:format%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarDateTimeUtcFormat</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%InitFileName%')">
                                <span class="variable-title">%InitFileName%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarInitFileName</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%InitFileNameExtension%')">
                                <span class="variable-title">%InitFileNameExtension%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarInitFileNameExtension</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%InitFileNameWithExtension%')">
                                <span class="variable-title">%InitFileNameWithExtension%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarInitFileNameWithExtension</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button width="100%" (onClick)="newParameter('%InitFileName:x_y%')">
                                <span class="variable-title">%InitFileName:x_y%</span>
                                <span class="variable-description" translate>fileTransfersRenamingParameters.lblVarInitFileNameXY</span>
                            </dx-button>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </dx-scroll-view>
</div>